<template>
  <div class="buttonNewGame">
    <el-button
      v-if="userHasPermission(permissions.apps.add)"
      class="submit-game"
      type="primary"
      data-test-id="myGamesEmptyStateCreateAppButton"
      @click="gotoSubmitFlow()">Create an App test</el-button>
  </div>
</template>

<script>
import permissions from '@/static/permissions';

export default {
  name: 'CreateAppButton',
  components: {},
  computed: {
    permissions() {
      return permissions;
    },
    myPermissions() {
      return this.$store.getters['users/myPermissions'];
    },
    loading() {
      return this.$store.getters['submitGame/loading'];
    },
  },
  watch: {},
  mounted() {},
  methods: {
    userHasPermission(value) {
      return this.myPermissions.indexOf(value) > -1;
    },
    gotoSubmitFlow() {
      this.$router.push({
        query: {
          game: undefined,
          studio: undefined,
          view: undefined,
          gameid: 'newapp',
        },
      });
      this.$emit('game-created');
    },
  },
};
</script>

<style lang="scss">
.buttonNewGame{
  .el-button {
    height: 32px;
  line-height: 0;
  padding-top: 10px;

  .el-icon-arrow-down {
    padding-left: 5px;
  }
  }
}
.new-game-modal {
  .formAction {
    padding: 20px;
    .name-requirement {
      margin-top: 10px;
      color: $darker-grey;
    }
  }
  .el-dialog__body {
    padding: 20px;
    .error {
      color: $blood-normal;
    }
    ul {
      li {
        padding: 10px;
        list-style: disc;
        margin-left: 20px;
        word-break: normal;
      }
    }
  }
}
</style>
